import { FloatingLabel, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Eye, EyeOff, AlertCircle } from "lucide-react"; // تم إضافة AlertCircle هنا

function MyInput({
  label,
  type = "text",
  value,
  onChange,
  required = false,
  error,
  as,
  options,
  disabled,
  name,
  dontShowDay = false,
  formData,
  percent,
  ...props
}) {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordType = type === "password";
  const actualType = isPasswordType
    ? showPassword
      ? "text"
      : "password"
    : type;

  const today = new Date().toISOString().split("T")[0];
  const inputValue =
    type === "date" ? (dontShowDay ? value || "" : value || today) : value;

  return (
    <div className="my-input-container mb-3 position-relative"> {/* تم إضافة position-relative هنا لضبط موضع الأيقونة */}
      <FloatingLabel
        label={
          <>
            {label}
            {required && (
              <span
                className="text-danger ms-1"
                style={{
                  fontSize: "1.6rem",
                  fontWeight: "bold",
                  verticalAlign: "middle",
                  marginRight: "5px",
                }}
              >
                *
              </span>
            )}
          </>
        }
      >
        {as === "select" ? (
          <Form.Select
            {...props}
            value={value}
            onChange={onChange}
            required={required}
            disabled={disabled}
            name={name}
            className={`${error ? "border-danger bg-danger bg-opacity-10" : ""}`} // تلوين بوردر وقوام السيلكت عند الخطأ
            style={{
              paddingLeft: error && !isRTL ? "40px" : undefined,
              paddingRight: error && isRTL ? "40px" : undefined,
            }}
          >
            {options.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Form.Select>
        ) : (
          <>
            <Form.Control
              {...props}
              type={actualType}
              placeholder=" "
              value={inputValue}
              onChange={(e) => {
                if (type === "number" && Number(e.target.value) < 0) {
                  return;
                }
                onChange(e);
              }}
              className={`mySA ${error ? "border-danger bg-danger bg-opacity-10" : ""} ${props.className}`} // تلوين البوردر والخلفية بنعومة باللون الأحمر عند الخطأ
              required={required}
              name={name}
              disabled={disabled}
              dir={isRTL ? "rtl" : "ltr"}
              style={{
                height: "200px !important",
                textAlign: isRTL ? "right" : "left",
                paddingLeft:
                  percent && !isRTL
                    ? "30px"
                    : isPasswordType && !isRTL
                      ? "40px"
                      : error && !isRTL
                        ? "40px" // حجز مساحة للأيقونة عند الخطأ لعدم تداخل النصوص
                        : undefined,
                paddingRight:
                  percent && isRTL
                    ? "30px"
                    : isPasswordType && isRTL
                      ? "40px"
                      : error && isRTL
                        ? "40px" // حجز مساحة للأيقونة عند الخطأ لعدم تداخل النصوص
                        : undefined,
              }}
            />

            {isPasswordType && (
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "var(--text-secondary)",
                  right: isRTL ? "unset" : "12px",
                  left: isRTL ? "12px" : "unset",
                  zIndex: 5,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            )}

            {percent && (
              <span
                style={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#424040ff",
                  fontSize: "20px",
                  pointerEvents: "none",
                  right: isRTL ? "10px" : "unset",
                  left: !isRTL ? "10px" : "unset",
                }}
              >
                %
              </span>
            )}
          </>
        )}
      </FloatingLabel>

      {/* عرض الخطأ كأيقونة عائمة ذكية داخل الحقل بدلاً من النص السفلي */}
      {error && (
        <span
          title={error} // تظهر رسالة الخطأ (مثل: هذا الحقل مطلوب) بمجرد وقوف الماوس على الأيقونة
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            color: "#dc3545",
            right: isRTL ? "unset" : "25px", // إذا كان الاتجاه عربي تظهر الأيقونة يساراً لمنع تداخلها مع النص
            left: isRTL ? "25px" : "unset",
            zIndex: 5,
            display: "flex",
            alignItems: "center",
            cursor: "help", // شكل الماوس يتحول لعلامة استفهام تلميحية
          }}
        >
          <AlertCircle size={20} className="animate-pulse" /> {/* أيقونة التنبيه الحمراء */}
        </span>
      )}
    </div>
  );
}

export default MyInput;